module.exports = __webpack_public_path__ + "img/appbar-wallpaper.af7da1cd.jpg";